export class userRegisterModel {
    email?: string = '';
    password?: string;
    confirmPassword?: string;
    user?: RegisterViewModel;
    code?: string;
    inviteCode?: string;
    entryUrl?: string;
    constructor() {
        this.user = new RegisterViewModel();
    }
}

export interface CheckUserStateBody {
    email: string | null;
    user: {
      username: string | '';
      phoneNumber: string | null;
    }
}

export class RegisterViewModel {
    firstname?: string = '';
    lastname?: string = '';
    username?: string = '';
    phoneNumber?: string = '';
}